// components
import Drawer from "../../drawer/Drawer";
import CustomButton from "../../kits/custom-button/CustomButton";

export default function CloseDrawer({ isOpen, setIsOpen, shopName }) {
  return (
    <>
      <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)} height={135}>
        <div className="demo-content pd-x-20 mr-t-16 desc-c-l">
          فروشگاه «{shopName}» بسته است.
        </div>
        <div className="d-flex mr-x-20 mr-t-20 mr-b-16">
          <CustomButton
            className="pd-x-16 w-50 w-100"
            buttonStyle="secondary"
            state="default"
            size="large"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <span className="title-h4-m">متوجه شدم</span>
          </CustomButton>
        </div>
      </Drawer>
    </>
  );
}
